export type PaginationType = {
  page: number;
  pageCount: number;
  total: number;
  count?: number;
}

export const defaultPagination: PaginationType = {
  page: 0,
  pageCount: 0,
  total: 0,
  count: 0,
};